import { render, staticRenderFns } from "./CourseCertificateBox.vue?vue&type=template&id=51b33637&scoped=true"
import script from "./CourseCertificateBox.vue?vue&type=script&lang=js"
export * from "./CourseCertificateBox.vue?vue&type=script&lang=js"
import style0 from "./CourseCertificateBox.vue?vue&type=style&index=0&id=51b33637&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b33637",
  null
  
)

export default component.exports